import React, { createRef } from 'react'
import ReactDOM from 'react-dom'
import { BaseNotifier } from './baseNotifier'
import BannerNotification from '../elementals/bannerNotification'

class PageBannerNotifier extends BaseNotifier {
  constructor() {
    super()
    this._containerDomNode = null
  }

  /**
   * For this initialize we pass in a containerRef such that the caller can specify
   * the node to attach the notification to (in the page)
   * @param {*} containerRef
   */
  initialize(containerRef) {
    const notificationSystem = createRef()

    this._containerDomNode = containerRef?.current
    if (this._containerDomNode) {
      ReactDOM.render(
        <BannerNotification ref={notificationSystem} />,
        this._containerDomNode
      )
    }
    super.initialize(notificationSystem)
  }

  open(options) {
    // open the notification system with the options defaulted using based prepareOptions function - may differ in future
    super.open(super.prepareOptions(options))
  }

  destroy() {
    // unmount and remove the notification from the container
    const containerDomNode = super.notificationSystem?.current
    if (containerDomNode && containerDomNode.parentNode) {
      ReactDOM.unmountComponentAtNode(containerDomNode)
    }
    super.destroy()
  }
}

export { PageBannerNotifier }
